import { AddCard, DeleteOutline } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import {
  addContribution as callAddContribution,
  deleteContribution as callDeleteContribution,
} from '../../../../http/PortfoliosApi';
import AddContributionDialog from './dialogs/AddContributionDialog';

export default function ContributionsListComponent({
  portfolio,
  contributions,
  reloadContributions,
  loadPortfolio,
  errMessage,
  setErrMessage,
  setSnackOpen,
  page,
  setPage,
}) {
  const [addContributionDialogOpen, setAddContributionDialogOpen] =
    React.useState(false);

  const handleChangePage = (event, newPage) => {
    reloadContributions(Number(newPage * 10), 10);
    setPage(newPage);
  };

  const formatDate = (date) => (date ? format(new Date(date), 'dd/MM/yy') : '');

  const amountFormatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  });

  const getAmountColor = (amount) => (Number(amount) > 0 ? 'black' : 'error');

  return (
    <Box>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'action.hover' }}>
              <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="right">
                Amount
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contributions?.items?.length > 0 ? (
              contributions.items.map((contribution) => (
                <TableRow key={contribution.id} hover>
                  <TableCell>{formatDate(contribution.timestamp)}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'medium' }}>
                    <Typography
                      label={contribution.amountEUR}
                      color={getAmountColor(contribution.amountEUR)}
                      fontSize="small"
                    >
                      {amountFormatter.format(contribution.amountEUR)}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() =>
                        callDeleteContribution(
                          portfolio?.id,
                          contribution?.id,
                        ).then(loadPortfolio)
                      }
                      size="small"
                    >
                      <DeleteOutline fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={3}
                  align="center"
                  sx={{ py: 3, color: 'text.secondary' }}
                >
                  No contributions recorded.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={contributions?.count || 0}
        rowsPerPage={10}
        rowsPerPageOptions={[]}
        page={page}
        onPageChange={handleChangePage}
        sx={{ borderTop: '1px solid divider' }}
      />
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          size="small"
          startIcon={<AddCard />}
          onClick={() => setAddContributionDialogOpen(true)}
        >
          Add Funds
        </Button>
      </Box>
      <AddContributionDialog
        addContribution={async (data) => {
          await callAddContribution(portfolio?.id, data);
          await loadPortfolio();
        }}
        addContributionDialogOpen={addContributionDialogOpen}
        setAddContributionDialogOpen={setAddContributionDialogOpen}
        errMessage={errMessage}
        portfolio={portfolio}
        setErrMessage={setErrMessage}
        setSnackOpen={setSnackOpen}
      />
    </Box>
  );
}
